import { EVENTDETAILS_LOAD, EVENTDETAILS_LOAD_SUCCESS, EVENTDETAILS_LOAD_FAIL, EVENTTOKEN_LOAD, EVENTTOKEN_LOAD_SUCCESS, EVENTTOKEN_LOAD_FAIL } from './actions';


const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  tokenForEvent: [],
  extraData: {},

};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case EVENTDETAILS_LOAD:
      return {
        ...state,
        loading: true,
      };
    case EVENTDETAILS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case EVENTDETAILS_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case EVENTTOKEN_LOAD:
      return {
        ...state,
        loading: true,
      };
    case EVENTTOKEN_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        tokenForEvent: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case EVENTTOKEN_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
}
